module.exports = __webpack_public_path__ + "static/img/gjwls.a0a6087b.png";